import { createTheme, type MantineColorsTuple } from '@mantine/core';
import { themeToVars } from '@mantine/vanilla-extract';

/*
 * Leadnize Color Palette
 * Primary colors:
 * - 362F4F: Dark purple/navy (backgrounds, dark elements)
 * - 5B23FF: Vibrant purple (primary actions)
 * - 008BFF: Bright blue (secondary actions, links)
 * - E4FF30: Lime green (accents, highlights)
 */

// Primary purple palette based on #5B23FF
export const leadnizePurple: MantineColorsTuple = [
  '#f3f0ff', // 0 - lightest
  '#e5deff', // 1
  '#d0c4ff', // 2
  '#b49eff', // 3
  '#9a7aff', // 4
  '#5B23FF', // 5 - primary
  '#4f1fe0', // 6
  '#431ac2', // 7
  '#3715a3', // 8
  '#2b1085' // 9 - darkest
];

// Blue palette based on #008BFF
export const leadnizeBlue: MantineColorsTuple = [
  '#e6f4ff', // 0 - lightest
  '#cce9ff', // 1
  '#99d3ff', // 2
  '#66bdff', // 3
  '#33a7ff', // 4
  '#008BFF', // 5 - primary
  '#0076d9', // 6
  '#0062b3', // 7
  '#004d8c', // 8
  '#003866' // 9 - darkest
];

// Accent lime palette based on #E4FF30
export const leadnizeLime: MantineColorsTuple = [
  '#fbffe6', // 0 - lightest
  '#f7ffcc', // 1
  '#efff99', // 2
  '#e8ff66', // 3
  '#e4ff33', // 4
  '#E4FF30', // 5 - primary
  '#c2d929', // 6
  '#a0b322', // 7
  '#7e8c1b', // 8
  '#5c6614' // 9 - darkest
];

// Dark purple palette based on #362F4F
export const leadnizeDark: MantineColorsTuple = [
  '#efeef2', // 0 - lightest
  '#dfdde5', // 1
  '#bfbbcb', // 2
  '#9f99b1', // 3
  '#7f7797', // 4
  '#5f557d', // 5
  '#4f4768', // 6
  '#362F4F', // 7 - primary dark
  '#2a243d', // 8
  '#1e192b' // 9 - darkest
];

export const theme = createTheme({
  colors: {
    leadnizePurple,
    leadnizeBlue,
    leadnizeLime,
    leadnizeDark
  },
  fontFamily:
    '"Geist Variable", Geist, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  fontFamilyMonospace:
    '"Fira Code", ui-monospace, SFMono-Regular, Monaco, Consolas, Liberation Mono, Courier New, monospace',
  headings: {
    fontFamily:
      '"Geist Variable", Geist, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '600'
  }
});

export const vars = themeToVars(theme);
